module.exports = __webpack_public_path__ + "img/lookbook_11.aa177890.png";